/*
Carousel for media contents and text explanation
*/
import React, { Component } from 'react';
import { 
  Carousel,
  CarouselCaption,
  CarouselControl,
  CarouselIndicators,
  CarouselItem } from "reactstrap";
import PropTypes from 'prop-types';
import Speaker from './Speaker';

export default class Cards extends Component {

  state = {
    activeIndex: 0
  }

  componentWillReceiveProps(nextProps){
    //dont need to fefresh cards because direclty using the props
    //reset the activeIndex to 0 instead
    this.setState({activeIndex: 0});
}

  onExiting = () => {
    this.setState({animating: true});
  }

  onExited = () => {
    this.setState({animating: false});
  }

  next = () => {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === this.props.cards.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous = () => {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? this.props.cards.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex = (newIndex) => {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    return (
        <Carousel
        className="caption"
          activeIndex={this.state.activeIndex}
          next={this.next}
          previous={this.previous}
          interval={false}
        >
          <CarouselIndicators 
            className="caption"
            items={this.props.cards} 
            activeIndex={this.state.activeIndex} 
            onClickHandler={this.goToIndex} 
          />
            {
              this.props.cards.map((card,i) =>(
                <CarouselItem
                  className="carouselItem"
                  key={i}
                  tag="div"
                  onExiting={this.onExiting}
                  onExited={this.onExited}
                >
                  <img className="carouselImg" src={card.imageUri} alt="imgs" />
                  <CarouselCaption className="caption" captionText={card.subtitle} captionHeader={card.title} />
                  <div style={buttonStyle}><Speaker text={card.subtitle} /></div>
                </CarouselItem>
              ))
            }
          <CarouselControl direction="prev" directionText="Prec" onClickHandler={this.previous} />
          <CarouselControl direction="next" directionText="Succ" onClickHandler={this.next} />
        </Carousel>
    );
  }
}

const buttonStyle = {
  textAlign: 'center',
  margin: '3px'
}

Cards.propTypes ={
  cards: PropTypes.array.isRequired
}